import React, { Component } from 'react'

class NotFound extends Component {
    render() { 
        return (
            <main id="body">
                <p>This page does not exist! Return to the home page.</p>
            </main>
        );
    }
}
 
export default NotFound;